import React from "react";
import { fireTag } from "./libs/analytics";
import { GAfireEvent } from "./components/Tracking";

export default {
	secondaryNav:{
		homepage:"Nuestras prioridades",
		ISF:"Instituto de Finanzas Sostenibles (en inglés)",
		HA:"Viviendas a precios asequibles"
	},
	modal:{
		title:<>Está saliendo del sitio Web de Wells&nbsp;Fargo</>,
		description: <>Está saliendo del sitio Web de Wells&nbsp;Fargo y está ingresando en un sitio Web que Wells&nbsp;Fargo no controla. Wells&nbsp;Fargo ofrece este enlace para su comodidad, pero no avala ni se hace responsable por el contenido, los enlaces, la política de privacidad o la política de seguridad de este sitio Web.</>,
		cancel: "Cancele",
		continue: "Continúe"
	},
	home: {
		pillarCards: [
			{
				id: 'housing',
				tracking: "S1",
				tabLabel: "Viviendas",
				icon: {
					src: "/images/pillar-cards/housing-icon.png",
					alt: "Ícono de una casa."
				},
				img: {
					src: "/images/pillar-cards/housing_2025_r2.jpg",
					alt: "Una mamá y su hija decoran cupcakes en la mesa de una cocina."
				},
				headline: "Haciendo, se crean más viviendas asequibles",
				body: <>Todos deben tener un lugar de calidad que puedan llamar hogar. Por eso estamos trabajando para apoyar y asistir a comunidades en todo el país y así lograr que más personas puedan tener su propio hogar o viviendas de calidad para arrendar.</>,
				stats: [
					{
						text: <>Más de $710 millones donados desde 2019 para ayudar a solucionar el problema de la accesibilidad y asequibilidad de viviendas en el país, lo que incluye apoyar a la iniciativa Keeping People Housed mediante la disponibilidad de viviendas a precios asequibles para arrendar y comprar</>
					},
					{
						text: <>$120 millones donados a Hábitat para la Humanidad Internacional y afiliados locales en apoyo a viviendas asequibles desde 2015</>
					},
					{
						text: <>$60 millones en subvenciones a través de nuestra iniciativa para ayudar a crear nuevos propietarios de vivienda en comunidades de ocho regiones del país</>
					}
				],
				cta: {
					intro: <>Mira cómo haciendo ayudamos a construir más soluciones de viviendas asequibles</>,
					ctaLabel: "Aprende más (en inglés)",
					newTab: true,
					href: "https://stories.wf.com/wells-fargo-volunteers-join-forces-to-build-27-homes-in-charlotte-with-habitat-for-humanity",
					ariaLabel: "Mira cómo haciendo ayudamos a construir más soluciones de viviendas asequibles."
				},
				quote: {
					text: <><q>Necesitamos urgentemente reimaginar el acceso a lugares de calidad para vivir, a precios asequibles, lo cual está estrechamente ligado a la estabilidad económica, la salud física y mental, y en última instancia, a la riqueza generacional</q>.</>,
					attrib: <><span lang='en'>Darlene Goins</span></>,
					attribTitle: <>Presidenta de <span lang="en">Wells&nbsp;Fargo</span> Foundation</>
				}
			},
			// {
			// 	id: 'sustainability',
			// 	tracking: "S2",
			// 	tabLabel: "La sostenibilidad y el clima",
			// 	icon: {
			// 		src: "/images/pillar-cards/sustainability-icon.png",
			// 		alt: "Ícono de una planta con dos hojas."
			// 	},
			// 	img: {
			// 		src: "/images/pillar-cards/sustainability_2025.jpg",
			// 		alt: "Un trabajador con casco instala paneles solares."
			// 	},
			// 	headline: "Haciendo, se crea un futuro más sostenible",
			// 	body: <>El cambio climático sigue siendo uno de los problemas ambientales y sociales más apremiantes de nuestro tiempo. Estamos trabajando en toda nuestra organización y a través de programas dedicados a ayudar a reducir los impactos del cambio climático en nuestras comunidades, empleados y clientes.</>,
			// 	stats: [
			// 		{
			// 			text: <>$50 millones donados a través de <span lang="en">Wells&nbsp;Fargo</span> Innovation Incubator (Incubadora de Innovación de <span lang="en">Wells&nbsp;Fargo</span>) a empresas emergentes de tecnología ecológica</>
			// 		},
			// 		{
			// 			text: <>$19.5 millones donados desde 2022 para proyectos y comunidades trabajando por un futuro más sostenible</>
			// 		},
			// 		{
			// 			text: <>$50 millones entregados entre 2018 y 2022 para ayudar a satisfacer las necesidades económicas, sociales y ambientales de comunidades de indígenas estadounidenses y nativos de Alaska</>
			// 		},
			// 		{
			// 			text: <>$500,000 mil millones dedicados a iniciativas de finanzas sostenibles antes de 2030</>
			// 		},
			// 	],
			// 	cta: {
			// 		intro: <>Mira cómo haciendo ayudamos a construir más realidades sostenibles a través de nuestro Instituto de Finanzas Sostenibles</>,
			// 		ctaLabel: "Aprende más (en inglés)",
			// 		href: "/sustainability/",
			// 		ariaLabel: "Mira cómo haciendo ayudamos a construir más realidades sostenibles a través de nuestro Instituto de Finanzas Sostenibles."
			// 	},
			// 	quote: {
			// 		text: <><q>Los hogares de menos ingresos son los más afectados por el cambio climático, y las soluciones deben enfocarse en ofrecer adaptación, acceso y costos asequibles a estas comunidades vulnerables</q>.</>,
			// 		attrib: <><span lang='en'>John Moon</span></>,
			// 		attribTitle: <>Director de Sostenibilidad, <span lang="en">Wells&nbsp;Fargo</span></>
			// 	}
			// },
			{
				id: 'small business',
				tracking: "S3",
				tabLabel: "Crecimiento de pequeñas empresas",
				icon: {
					src: "/images/pillar-cards/small-business-icon.png",
					alt: "Ícono de dos manos estrechándose"
				},
				img: {
					src: "/images/pillar-cards/small-business_2025.jpg",
					alt: "Una mujer en su delantal y sonriente abre la puerta de su tienda."
				},
				headline: "Haciendo, se construyen empresas sólidas",
				body: <>Las pequeñas empresas son la base de nuestras comunidades, y tenemos el compromiso de realizar inversiones significativas para ayudarlas a tener éxito.</>,
				stats: [
					{
						text: <>Desde 2020, hemos donado cerca de $420 millones a través del <span lang='en'>Open for Business Fund</span> (Fondo ‘Abiertos al Público’), el cual ha provisto a más de 200 Instituciones Financieras para el Desarrollo Comunitario (CDFI, por sus siglas en inglés) y otras organizaciones sin fines de lucro de recursos para ayudar a que los dueños de pequeñas empresas puedan salir adelante. Este financiamiento ha ayudado a más de 336,000 pequeñas empresas y les ha posibilitado crear o conservar más de 461,000 puestos de trabajo<sup><a href="#footnote-1" onClick={(e) => {
							e.preventDefault();
							document.querySelector('#footnote-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#footnote-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}
						onKeyUp={(e) => {if(e.which === '13'){
							e.preventDefault();
							document.querySelector('#footnote-1').focus();
							window.scrollBy(
								0,
								document.querySelector('#footnote-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
							);
						}}} id="ref-1" className="disc-sup reference-num" data-go-to="footnote-1" data-cat-id="0" aria-label="Link to the number 1 disclaimer in footer." tabIndex="0">1</a></sup> en comunidades locales</>,
					},
					{
						text: <>1,400 oportunidades adicionales de mentoría gratuita y 17,000 horas de asistencia técnica a empresarias a través de nuestro programa <a lang="en" href='https://www.wellsfargo.com/small-business/jump/other/connect-to-more' target='_blank' onClick={() => fireTag('C10')} rel="noreferrer">Connect to More&#8480;</a> (en inglés) entre 2022 y 2023</>,
					}
				],
				// story: {
				// 	img: {
				// 		src: "/images/pillar-cards/small-business-story.jpg",
				// 		alt: "Hombre y mujer mirando a la cámara mientras sonríen"
				// 	},
				// 	text: "Las inversiones y el apoyo significativo mantienen abiertas las puertas de las pequeñas empresas (en inglés)",
				// 	href: "https://stories.wf.com/meaningful-investments-and-support-keep-small-business-doors-open",
				// 	target: "_blank"
				// },
				cta: {
					intro: <>Mira cómo haciendo ayudamos a construir el éxito de las pequeñas empresas</>,
					ctaLabel: "Aprende más (en inglés)",
					href: "https://smallbusinessresources.wf.com/diverse/",
					ariaLabel: "Mira cómo haciendo ayudamos a construir el éxito de las pequeñas empresas",
					newTab: true
				},
				quote: {
					text: <><q>Desde la creación de empleos hasta la innovación, las pequeñas empresas y organizaciones sin fines de lucro locales están transformando nuestras comunidades</q>.</>,
					attrib: <><span lang='en'>Darlene Goins</span></>,
					attribTitle: <>Presidenta de <span lang='en'>Wells Fargo Foundation</span></>
				}
			},
			{
				id: 'financial health',
				tracking: "S4",
				tabLabel: "Bienestar financiero",
				icon: {
					src: "/images/pillar-cards/financial-icon.png",
					alt: "Ícono de un gráfico en forma de rosquilla."
				},
				img: {
					src: "/images/pillar-cards/financial_2025.jpg",
					alt: "Una mujer joven escribe en una computadora portátil mientras está sentada en una mesa con libros abiertos."
				},
				headline: "Haciendo, se fortalecen los futuros financieros",
				body: <>Creemos que todos deben tener acceso a formas seguras, asequibles y responsables de manejar sus finanzas y a tener educación financiera. Por eso nos enfocamos en apoyar programas que ayuden a brindar acceso a formas seguras, asequibles y responsables de construir un futuro financiero mejor.</>,
				stats: [
					{
						text: <>Entre 2019 y 2023, proveímos cerca de $58 millones para becas y programas extracurriculares para estudiantes a través de organizaciones sin fines de lucro</>
					},
					// {
					// 	text: <>Entre 2020 y 2023, asignamos $5.6 millones en subvenciones para poner en marcha nuestra iniciativa de salud financiera Our Money Matters (“Nuestro dinero importa”) en universidades históricamente para personas negras (<span lang='en'>HBCU</span>, por sus siglas en inglés) y campus de instituciones docentes que atienden minorías</>
					// },
					// {
					// 	text: <>En 2021, cumplimos nuestra promesa de <a lang="es" onClick={()=>fireTag('C6')} href="https://newsroom.wf.com/English/news-releases/news-release-details/2021/Wells-Fargo-Completes-Investments-in-13-Black-Owned-Banks-Fulfilling-50-Million-Pledge-Made-in-2020/default.aspx " target="_blank" rel="noreferrer">aportar $50 millones</a> (en inglés) en apoyo a bancos de propietarios negros y afroamericanos, mediante la inversión en 13 Instituciones Depositarias de Minorías (<span lang='en'>MDI</span>, por sus siglas en inglés)</>
					// },
					{
						text: <>
						En mayo de 2021, lanzamos nuestra <a href="https://www.wellsfargo.com/es/jump/enterprise/banking-inclusion-initiative/" target='_blank' onClick={() => fireTag("C6")} rel="noreferrer">Iniciativa de Inclusión Bancaria</a>, un compromiso de 10 años enfocado en acelerar el acceso a cuentas convencionales asequibles a comunidades sin acceso o con acceso limitado a servicios bancarios convencionales, y proveer un acceso más fácil a servicios bancarios de bajo costo y a la educación financiera
						</>
					}
				],
				// story: {
				// 	img: {
				// 		src: "/images/pillar-cards/financial-story.jpg",
				// 		alt: "Grupo de adultos en ropa profesional frente a globos, sosteniendo una cinta grande."
				// 	},
				// 	text: "El primer banco de Minnesota propiedad de una persona negra (en inglés)",
				// 	href: "https://stories.wf.com/minnesotas-first-black-owned-bank?adlt=strict",
				// 	target: "_blank"
				// },
				quote: {
					text: <><q>Estamos comprometidos con invertir en soluciones que ayudan a las personas a alcanzar mayor estabilidad y seguridad financiera a largo plazo, reducir sus preocupaciones y planificar para el futuro</q>.</>,
					attrib: <><span lang='en'>Bonnie Wallace</span></>,
					attribTitle: <>Directora de Filantropía para el Bienestar Financiero, <span lang="en">Wells&nbsp;Fargo</span></>
				}
			}
		],
		panel1: [
			{
				split1: ['2 million', 'Wells Fargo Team Member', 'Volunteer Hours'],
				split2:
					' Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. ',
			},
			{
				split1: ['286.5 million', 'Donated to 14,500', 'Non profits'],
				split2:
					' Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. community.. Our community.. Our community.. ',
			},
		],
		stats: {
			headline: "Making a real impact through action",
			tiles: [
				{
					title: "$1B Small Business Financing",
					copy: "Approximately $1 billion in available financing is expected to help entrepreneurs through the Open for Business Fund",
					mail: {"body": "Approximately $1 billion in available financing is expected to help entrepreneurs through the Wells Fargo Open for Business Fund — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				},
				{
					title: "$175MM Invested to Grow Local Jobs",
					copy: "We’re empowering diverse small business owners to grow and sustain local jobs by investing $175 million in Wells Fargo Diverse Community Capital (DCC)",
					mail: {"body": "Wells Fargo is empowering diverse small business owners to grow and sustain local jobs by investing $175 million in Wells Fargo Diverse Community Capital (DCC) — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				},
				{
					title: "Helping 72K+ Black Homeowners",
					copy: "Through 2020, we helped 72,759 Black families and individuals become homeowners through $18.6 billion in mortgage financing",
					mail: {"body": "Through 2020, Wells Fargo helped 72,759 Black families and individuals become homeowners through $18.6 billion in mortgage financing — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				},
				{
					title: "$75B to Support Sustainability",
					copy: "Wells Fargo deployed $75 billion in financing to sustainable businesses and projects to accelerate the transition to a low-carbon economy",
					mail: {"body": "Wells Fargo deployed $75 billion in financing to sustainable businesses and projects to accelerate the transition to a low-carbon economy — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				},
				{
					title: "Helped 188K+ Hispanic Homeowners",
					copy: "Through 2020, Wells Fargo helped 188,460 Hispanic families and individuals become homeowners through $48.7 billion in mortgage financing",
					mail: {"body": "Through 2020, Wells Fargo helped 188,460 Hispanic families and individuals become homeowners through $48.7 billion in mortgage financing — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				},
				{
					title: "$475MM Donated",
					copy: "Through our businesses and the Wells Fargo Foundation, our charitable contributions totaled $475 million in 2020",
					mail: {"body": "Through Wells Fargo’s businesses and the Wells Fargo Foundation, charitable contributions totaled $475 million in 2020 — and that’s just one of the ways they’re working hard to advance economic opportunities, racial equity, and sustainability. \r\rLearn more about their commitment now at https://welcome.wf.com/impact"}
				}
			]
		},
		grant: {
			headline: "Estrategia focalizada para marcar la diferencia en tu&nbsp;comunidad",
			copy: `<span lang='en'>Wells&nbsp;Fargo</span> y <span lang='en'>Wells&nbsp;Fargo</span> Foundation colaboran con organizaciones sin fines de lucro nacionales y locales para apoyar oportunidades económicas, propietarios de pequeñas empresas y viviendas asequibles.`,
			alt: "Voluntario de Wells Fargo sonríe mientras transporta tierra con una carretilla",
			link: {
				label: "Aprende más sobre nuestro proceso de subvenciones (en inglés)",
				url: "https://www.wellsfargo.com/about/corporate-responsibility/community-giving/"
			}
		},
		violator: {
			icon: "/images/housing/programs-resources/house-percent.svg",
			alt: "Icon of a house.",
			headline: "See all the ways we’re tackling housing affordability",
			subhead: "Learn more about how we’re working to preserve, build, and develop innovative solutions for&nbsp;housing&nbsp;affordability."
		}
	},
	housing: {
		masthead: {
			headline: '',
			facets: [
				{
					title: "Más viviendas a precios asequibles",
					summary: "En los últimos cinco años, hemos aportado más de $21,000 millones en capital para el desarrollo y la rehabilitación de más de 72,000 apartamentos de arrendamiento asequibles y de calidad"
				},
				{
					title: "Más opciones de financiamiento",
					summary: "Hemos hecho posible que más de 80,000 compradores calificados realicen un pago inicial del 5% o menos para su primera vivienda durante los últimos 5 años"
				},
				{
					title: "Más innovaciones en la vivienda",
					summary: "Hemos otorgado $15 millones a seis soluciones innovadoras y escalables para aumentar el acceso a la vivienda a precio asequible"
				}
			]
		},
		solutions: {
			headline: "Más formas en que abordamos el acceso a la vivienda a precio asequible",
			subhead: "Financing developers to build more homes, offering homebuyers flexible financing options, and innovating housing for the future.",
			body: "Financing developers to build more homes, offering homebuyers flexible financing options, and innovating housing for the future.",
			tiles: [
				{
					imgAlt: "Una persona mide con un lápiz la estatura de una niña en una pared.",
					body: "Hemos aportado casi $450 millones en capital flexible a Instituciones Financieras para el Desarrollo Comunitario y a constructoras de viviendas sin fines de lucro.",
					problem: "There has long been a drastic shortage of home options for low-income families,",
					solution: "so we invested more than $4B into more affordable rental housing in 2020.<a href='#footnote-1' id='ref-1' class='disc-sup reference-num' data-go-to='footnote-1' data-cat-id='1' aria-label='Link to disclaimer 1 in footer.' tabindex='-1'><sup>1</sup></a>",
					attrib: "rent solution",
					attribTitle: ""
				},
				{
					imgAlt: "Dos personas se abrazan frente a una puerta principal con vidriera policromada.",
					body: "Aportaremos <a id='stat-link-1' href='https://newsroom.wf.com/English/news-releases/news-release-details/2022/Wells-Fargo-Expands-Efforts-to-Advance-Racial-Equity-in-Homeownership/default.aspx' target='_blank'>$150 millones</a> (en inglés) para reducir los costos de refinanciamiento y así ayudar a propietarios de casa de minorías a beneficiarse aún más del refinanciamiento.",
					problem: "While rising prices have prevented many first-time buyers from entering the market,",
					solution: "we’ve helped more than 80k people purchase homes with down payments of 5% or less.<a href='#footnote-2' id='ref-2' class='disc-sup reference-num' data-go-to='footnote-2' data-cat-id='2' aria-label='Link to disclaimer 2 in footer.' tabindex='-1'><sup>2</sup></a>",
					cta: {
						text: "Learn more",
						url: "https://newsroom.wf.com/English/news-releases/news-release-details/2022/Wells-Fargo-Expands-Efforts-to-Advance-Racial-Equity-in-Homeownership/default.aspx"
					},
					attrib: "buy solution",
					attribTitle: ""
				},
				{
					imgAlt: "Una persona sentada en el suelo hace burbujas que niños tratan de atrapar en el aire.",
					body: "Hemos donado más de $390 millones para abordar la compra y el arrendamiento de viviendas a precios asequibles y la estabilidad de la vivienda.",
					problem: "Too many BIPOC community members are locked out of the housing market.",
					solution: "With the WORTH program (2022), we’ve provided $60MM+ to non-profits, helping create 40k BIPOC homebuyers over eight markets.",

					attrib: "generation solution",
					attribTitle: ""
				}
			]
		},
		featuredNew: {
			headline: "Obtén más información sobre nuestro compromiso con el acceso a la vivienda a precio asequible",
			tiles: [
				{
					medium: "article",
					title: "",
					alt: "Dos personas acostadas en el suelo juntan sus cabezas y sonríen.",
					copy: "Posibilitamos que hacer realidad el sueño de comprar una vivienda sea accesible para todos los estadounidenses (en inglés)",
					attrib: "homeownership",
					btn: {
						copy: "Lectura de 6 minutos",
						href: "https://stories.wf.com/making-homeownership-accessible-to-all-americans/"
					},
					trackingLabel: "read: accessible homeownership"
				},
				{
					medium: "article",
					"title-old": "MANNA INC.",
					title: "",
					alt: "Dos personas caminan por la acera, una mira a la otra.",
					copy: "Ayudamos a que los residentes del Distrito de Columbia compren su propia casa (en inglés)",
					attrib: "manna",
					btn: {
						external: true,
						copy: "Lectura de 6 minutos",
						href: "/impact/organization/?search=3759457 "
					},
					time: "3:23",
					trackingLabel: "watch: manna inc"
				},
				{
					medium: "article",
					"title-old": "",
					title: "",
					alt: "Una persona sostiene a una niña frente a una casa.",
					copy: "Este programa ayuda a los indígenas estadounidenses a comprar una casa y mejorar su perspicacia financiera (en inglés)",
					attrib: "native americans",
					btn: {
						copy: "Lectura de 4 minutos",
						href: "https://stories.wf.com/program-helps-native-americans-buy-a-home-gain-financial-acumen/"
					},
					time: "",
					trackingLabel: "watch: financial health"
				},
				{
					medium: "article",
					title: "",
					alt: "Plano aéreo de edificios de apartamentos en una ciudad.",
					copy: `<span lang='en'>Wells Fargo</span> amplía sus esfuerzos para promover la equidad racial en la compra de viviendas (en inglés)`,
					tag: 'amplía sus esfuerzos para promover la equidad racial en la compra de viviendas (en inglés)',
					attrib: "house heros",
					btn: {
						copy: "Lectura de 5 minutos",
						href: "https://newsroom.wf.com/English/news-releases/news-release-details/2022/Wells-Fargo-Expands-Efforts-to-Advance-Racial-Equity-in-Homeownership/default.aspx"
					},
					trackingLabel: "read: house of heroes"
				}

			]
		},

		committed: {
			headline: "Estamos comprometidos con nuestras comunidades",
			copy: "Conoce más sobre otras maneras en las que estamos fortaleciendo nuestros vecindarios",
			alt: "A street in a small town with the sun setting in the background.",
			link: {
				label: "Learn more about our grant process",
				url: "/impact/"
			}
		},
		"programs-resources": {
			headline: "Recursos y educación adicionales",
			tiles: [
				{
					icon: "/images/housing/programs-resources/calendar-check.svg",
					alt: "Ícono de un calendario con una marca de verificación.",
					headline: <><span lang='en'>Dream. Plan. Home.&#8480;&nbsp;<a href='#footnote-1' id='ref-1' className='disc-sup reference-num' data-go-to='footnote-1' onClick={(e) => {
						e.preventDefault();
						document.querySelector('#footnote-1').focus();
						window.scrollBy(
							0,
							document.querySelector('#footnote-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
						);
					}}
					onKeyUp={(e) => {if(e.which === '13'){
						e.preventDefault();
						document.querySelector('#footnote-1').focus();
						window.scrollBy(
							0,
							document.querySelector('#footnote-1').getBoundingClientRect().top - document.querySelector('nav').getBoundingClientRect().height
						);
					}}} data-cat-id='0' aria-label='Link to disclaimer in footer.' tabIndex='0'>*</a></span></>,
					subhead: "Crédito para los costos de cierre (en inglés)",
					linkNew: "https://www.wellsfargo.com/mortgage/jump/closing-cost-credit/",
					link: "https://www.wellsfargo.com/mortgage/jump/closing-cost-credit/",
					trackingMeta: "housing_C7",
					tag:'dream. plan. home.'
				},
				{
					icon: "/images/housing/programs-resources/document-seal.svg",
					alt: "Ícono de un documento certificado.",
					headline: <>Préstamos hipotecarios para prestatarios de ingresos bajos a moderados</>,
					subhead: "Educación financiera",
					link: "https://www.wellsfargo.com/es/financial-education/homeownership/low-income-home-loans/",
					trackingMeta: "housing_C8",
					tag:'préstamos hipotecarios para prestatarios de ingresos bajos a moderados'
				},
				{
					icon: "/images/housing/programs-resources/key.svg",
					alt: "Ícono de una liave",
					headline: <>Ser propietario de una casa</>,
					subhead: "Educación financiera",
					link: "https://www.wellsfargo.com/es/financial-education/homeownership/",
					trackingMeta: "housing_C9",
					tag:'ser propietario de una casa'
				}
			]
		}
	},
	sustainability: {
		masthead: {
			headline: 'At Wells Fargo, we support our clients, customers, and communities in their transition to a resilient, equitable, and sustainable future.',
			facets: [
				"Scale clean energy",
				"Increase sustainability where we live and work",
				"Advance climate finance and innovation",
				"Support an equity-focused transition",
			]
		},
		perspectives: {
			headline: "Perspectives",
			subhead: "Financing developers to build more homes, offering homebuyers flexible financing options, and innovating housing for the future.",
			body: "Financing developers to build more homes, offering homebuyers flexible financing options, and innovating housing for the future.",
			tiles: [
				{
					imgAlt: "A person looking straight at the camera and smiling.",
					header: "An equitable, low-carbon future should be a priority today",
					subheader: "by Robyn Luhning, chief sustainability officer at Wells Fargo",
					url: "https://www.forbes.com/sites/forbesfinancecouncil/2022/10/05/an-equitable-low-carbon-future-should-be-a-priority-today/",
					attrib: "continuous-learning",
					attribTitle: ""
				},
				{
					imgAlt: "A \"CO2\" graphic set against a field with a blue, cloudy sky. A picture of trees fills in the \"O\" in the graphic.",
					header: "Bill Daley and Mike Santomassimo on Wells Fargo’s commitment to reducing greenhouse gas emissions",
					subheader: "by Amy Gustafson / Video produced by William Gallego ",
					url: "https://stories.wf.com/wells-fargos-commitment-to-reducing-greenhouse-gas-emissions?cid=intpart_wfs_isflp_2208_0",
					attrib: "bill-and-mike",
					attribTitle: ""
				},
				{
					imgAlt: "Two people examine an electric car charging cable.",
					header: "Putting cleantech innovations to the test",
					subheader: "by Trish Cozart, director of the National Renewable Energy Laboratory’s Innovation and Entrepreneurship Center",
					url: "https://www.greenbiz.com/article/putting-cleantech-innovations-test ",
					attrib: "nre-lab",
					attribTitle: ""
				},
				{
					imgAlt: "A person looking straight at the camera and smiling.",
					header: "Climate change is a racial justice issue",
					subheader: "by Emi Wang, associate director of Capacity Building for The Greenlining Institute",
					url: "https://stories.wf.com/climate-change-is-a-racial-justice-issue?cid=intpart_wfs_isflp_2208_0",
					attrib: "racial-justice",
					attribTitle: ""
				},
				{
					imgAlt: "A person looking straight at the camera and smiling while their hand touches the side of their face.",
					header: "Aligning entire sectors of the economy with climate goals is a complex process",
					subheader: "by Jules Kortenhorst, former CEO of RMI",
					url: "https://stories.wf.com/aligning-entire-sectors-of-the-economy-with-climate-goals-is-a-complex-process?cid=intpart_wfs_isflp_2208_0",
					attrib: "aligning-sectors",
					attribTitle: ""
				},
			]
		},
		highlights: {
			headline: "Highlights",
			tiles: [
				{
					tab: {
						header: "Deploying approximately $68 billion in sustainable financing in 2021*",
						subheader: "This represents the first year of our commitment to deploy $500 billion by 2030.",
						cta: {
							copy: "View report",
							href: "https://www.wellsfargo.com/assets/pdf/about/corporate-responsibility/sustainable-finance-progress.pdf",
							gaTag: "isf_C10",
						},
						ariaLabel: "Item Three",
						altText: "Graphic showing that $68B has been deployed. Of that, $36B went toward Standard-Aligned Sustainable Finance, $20B went to Environmental Finance, and $12B went to Social Finance.",
						gaTag: "isf_C5",
					},
					panel: {
						header: "This represents the first year of our commitment to deploy $500 billion between 2021 and 2030.",
						cta: {
							copy: "View report",
							href: "https://www.wellsfargo.com/assets/pdf/about/corporate-responsibility/sustainable-finance-progress.pdf",
							gaTag: "isf_C10",
						},
						subheader: "",
						imageClass: "image-3",
						altText: "Graphic showing that $68B has been deployed. Of that, $36B went toward Standard-Aligned Sustainable Finance, $20B went to Environmental Finance, and $12B went to Social Finance."
					}
				},

				{
					tab: {
						header: "Accelerating the path for clean tech entrepreneurs",
						subheader: "The Wells Fargo Innovation Incubator (IN<sup>2</sup>) is an award-winning $50 million collaboration with the U.S. Department of Energy’s National Renewable Energy Laboratory. IN<sup>2</sup> aims to accelerate the path to market for promising clean technology, sustainable agriculture, and residential housing startups.",
						cta: {
							copy: "Learn more",
							href: "https://in2ecosystem.com/innovating-for-impact-in2-annual-report-2021/",
							gaTag: "isf_C11",
						},
						ariaLabel: "Item Two",
						altText: "Side-by-side picture showing a suburban house in the left frame with the word “Housing” underneath, a skyscraper office building in the middle frame with the words “Commercial buildings” underneath, and plants in a greenhouse in the right frame with “Sustainable agriculture” underneath.",
						gaTag: "isf_C6",
					},
					panel: {
						header: "The Wells Fargo Innovation Incubator (IN<sup>2</sup>) is an award-winning $50 million collaboration with the U.S. Department of Energy’s National Renewable Energy Laboratory. IN<sup>2</sup> aims to accelerate the path to market for promising clean technology, sustainable agriculture, and residential housing startups.",
						subheader: "",
						cta: {
							copy: "Learn more",
							href: "https://in2ecosystem.com/innovating-for-impact-in2-annual-report-2021/",
							gaTag: "isf_C11",
						},
						imageClass: "image-1",
						altText: "Side-by-side picture showing a suburban house in the left frame with the word “Housing” underneath, a skyscraper office building in the middle frame with the words “Commercial buildings” underneath, and plants in a greenhouse in the right frame with “Sustainable agriculture” underneath."
					}
				},

				{
					tab: {
						header: "Providing financing with first sustainability bond",
						subheader: "Our $1 billion Inclusive Communities and Climate Bond, issued in 2021, funds projects and programs that support housing affordability, socioeconomic opportunity, and renewable energy across 11 states.",
						cta: {
							copy: "View report",
							href: "https://www08.wellsfargomedia.com/assets/pdf/about/corporate-responsibility/inclusive-communities-climate-bond-report.pdf",
							gaTag: "isf_C14",
						},
						ariaLabel: "Item Five",
						altText: "Doughnut graph showing that 37% of the bond money went toward Housing affordability, 14% went toward Socioeconomic advancement and empowerment, and 49% went towards Renewable energy",
						gaTag: "isf_C8",
					},
					panel: {
						header: "Our $1 billion Inclusive Communities and Climate Bond, issued in 2021, funds projects and programs that support housing affordability, socioeconomic opportunity, and renewable energy across 11 states.",
						cta: {
							copy: "View report",
							href: "https://www08.wellsfargomedia.com/assets/pdf/about/corporate-responsibility/inclusive-communities-climate-bond-report.pdf",
							gaTag: "isf_C14",
						},
						subheader: "",
						imageClass: "image-4",
						altText: "Doughnut graph showing that 37% of the bond money went toward Housing affordability, 14% went toward Socioeconomic advancement and empowerment, and 49% went towards Renewable energy"
					},

				},

				{
					tab: {
						header: "Working towards net-zero emissions by 2050",
						subheader: "We joined the industry-led Net-Zero Banking Alliance, which represents about 40% of global banking assets and is committed to aligning lending and investment portfolios with net-zero emissions by 2050.",
						cta: {
							copy: "Learn more",
							href: "https://www.unepfi.org/net-zero-banking/",
							gaTag: "isf_C13",
						},
						ariaLabel: "Item Four",
						altText: "Picture of a person smiling and typing on a tablet while standing inside a greenhouse.",
						gaTag: "isf_C7"
					},
					panel: {
						header: "We joined the industry-led Net-Zero Banking Alliance, which represents over $130 trillion of private capital globally and is committed to aligning lending and investment portfolios with net-zero emissions by 2050.",
						cta: {
							copy: "Learn more",
							href: "https://www.unepfi.org/net-zero-banking/",
							gaTag: "isf_C13",
						},
						subheader: "",
						imageClass: "image-2",
						altText: "Picture of a person smiling and typing on a tablet while standing inside a greenhouse."
					}
				},


			]
		},
		featured: {
			headline: "News from the ISF",
			tiles: [
				{
					medium: "article",
					alt: "An aerial view of a city neighborhood. Large trees grow over the street, with residential housing in the foreground and industrial buildings and a rail line in the background.",
					title: "",
					copy: "Clean heating at cool costs",
					attrib: "image 10",
					btn: {
						external: true,
						copy: "4 min read",
						href: "https://stories.wf.com/clean-heating-at-cool-costs"
					},
					time: ""
				},
				{
					medium: "article",
					title: "",
					alt: "Two people lay their heads next to each other on the ground and smile.",
					copy: "Making homeownership accessible to all Americans",
					attrib: "homeownership",
					btn: {
						copy: "6 min read",
						href: "https://stories.wf.com/making-homeownership-accessible-to-all-americans/"
					},
					trackingLabel: "read: accessible homeownership"
				},
				{
					medium: "article",
					"title-old": "MANNA INC.",
					title: "",
					alt: "Two people walk down the sidewalk together while one looks at the other.",
					copy: "Helping District of Columbia residents purchase a home of their own",
					attrib: "manna",
					btn: {
						external: true,
						copy: "6 min read",
						href: "/impact/organization/?search=3759457 "
					},
					time: "3:23",
					trackingLabel: "watch: manna inc"
				},
				{
					medium: "article",
					"title-old": "",
					title: "",
					alt: "Person holds child in front of a house.",
					copy: "Program helps Native Americans buy a home, enhance financial acumen",
					attrib: "native americans",
					btn: {
						copy: "4 min read",
						href: "https://stories.wf.com/program-helps-native-americans-buy-a-home-gain-financial-acumen/"
					},
					time: "",
					trackingLabel: "watch: financial health"
				},
				{
					medium: "article",
					title: "",
					alt: "Overhead shot of apartment buildings in a city.",
					copy: "Wells Fargo expands efforts to advance racial equity in homeownership",
					attrib: "house heros",
					btn: {
						copy: "5 min read",
						href: "https://newsroom.wf.com/English/news-releases/news-release-details/2022/Wells-Fargo-Expands-Efforts-to-Advance-Racial-Equity-in-Homeownership/default.aspx"
					},
					trackingLabel: "read: house of heroes"
				}
			]
		},
		"featured-large": {
			headline: "Latest news and stories",
			tiles: [
				{
					medium: "video",
					alt: "A hand holding an electric vehicle charger with a graphic showing \"Net zero emissions by 2050\" on top of it.",
					title: "Spotlight: Avangrid",
					copy: "Inside America’s Biggest Off-Shore Wind Farm",
					attrib: "image 0",
					btn: {
						external: true,
						copy: "Watch",
						alt: "Inside America’s Biggest Off-Shore Wind Farm",
						href: "https://www.wellsfargo.com/cib/focus/stories/avangrid/"
					},
					time: "2:00",
					timeAria: "Duration: 2 minutes",
					trackingLabel: "read: accessible homeownership"
				},
				{
					medium: "video",
					alt: "A row of escalators with a graphic showing “$220 million in Transit Improvements” on top of it.",
					title: "Spotlight: SL Green Realty",
					copy: "Wells Fargo — Bringing NYC Back Bigger and Better",
					attrib: "image 1",
					btn: {
						external: true,
						copy: "Watch",
						alt: "Wells Fargo - Bringing NYC Back Bigger & Better",
						href: "https://www.wellsfargo.com/cib/focus/stories/slgreen/"
					},
					time: "2:00",
					timeAria: "Duration: 2 minutes",
					trackingLabel: "watch: manna inc"
				},
				{
					medium: "article",
					alt: "A row of solar panels with the sun setting behind them.",
					title: "",
					copy: "Soaking up the sun at work",
					attrib: "image 2",
					btn: {
						external: true,
						copy: "2 min read",
						href: "https://stories.wf.com/soaking-up-the-sun-at-work?cid=intpart_wfs_isflp_2208_0"
					},
					time: "",
					trackingLabel: "watch: financial health"
				},
				{
					medium: "article",
					alt: "A field of wind turbines.",
					title: "",
					copy: "Wells Fargo surpasses $10 billion in tax-equity financing of renewable energy projects",
					attrib: "image 3",
					btn: {
						external: true,
						copy: "4 min read",
						href: "https://stories.wf.com/wells-fargo-surpasses-10-billion-in-tax-equity-financing-of-renewable-energy-projects?cid=intpart_wfs_isflp_2208_0"
					},
					trackingLabel: "read: house of heroes"
				},
				{
					medium: "video",
					alt: "A sunset over a mountain range.",
					title: "",
					copy: "Helping the Hopi and Navajo Nations build safer homes and resilient communities",
					attrib: "image 4",
					btn: {
						external: true,
						copy: "Watch",
						alt: "Red Feather Development Group provides solar furnaces and more to the Hopi and Navajo Nations",
						href: "https://stories.wf.com/helping-the-hopi-and-navajo-nations-build-safer-homes-and-resilient-communities?cid=intpart_wfs_isflp_2208_0"
					},
					time: "2:22",
					timeAria: "Duration: 2 minutes, 22 seconds",
					trackingLabel: "read: accessible homeownership"
				},
				{
					medium: "article",
					alt: "A row of people with helmets and goggles sitting on motorcycles.",
					title: "",
					copy: "Getting the next generation amped up about electric minicycles",
					attrib: "image 5",
					btn: {
						external: true,
						copy: "2 min read",
						href: "https://stories.wf.com/getting-the-next-generation-amped-up-about-electric-minicycles?cid=intpart_wfs_isflp_2208_0"
					},
					trackingLabel: "watch: manna inc"
				}
			]
		},
		committed: {
			headline: "We're committed to our communities",
			copy: "Learn more about the other ways we’re stepping up in our local neighborhoods",
			alt: "A person standing in a yard with two children smiling and looking up while the sun sets.",
			link: {
				label: "Learn more about our grant process",
				url: "/impact/"
			}
		},
		"programs-resources": {
			headline: "Additional resources",
			tiles: [
				{
					icon: "",
					alt: "",
					headline: "CO2eMission&#8480;",
					subhead: "Net-zero goal and interim targets",
					linkNew: "",
					link: "https://sites.wf.com/co2emission/",
					trackingMeta: ""
				},
				{
					icon: "",
					alt: "",
					headline: "Sustainability Goals and Reporting",
					subhead: "ESG strategy, activities, and performance",
					link: "https://www.wellsfargo.com/about/corporate-responsibility/goals-and-reporting/",
					trackingMeta: ""
				},

				{
					icon: "",
					alt: "",
					// headline: "Innovation Incubator (&nbsp;IN&nbsp;<sup>2</sup>&nbsp;)",
					headline: "Innovation Incubator (IN<sup>2</sup>)",
					subhead: "Cleantech innovation collaboration",
					linkNew: "",
					link: "https://in2ecosystem.com/",
					trackingMeta: ""
				},
				{
					icon: "",
					alt: "",
					headline: "$1B Inclusive Communities and Climate Bond",
					subhead: "Sustainable finance",
					link: "https://www08.wellsfargomedia.com/assets/pdf/about/corporate-responsibility/inclusive-communities-climate-bond-report.pdf",
					trackingMeta: ""
				},
				{
					icon: "",
					alt: "",
					headline: "Net-Zero Banking Alliance",
					subhead: "Industry-led collaboration",
					link: "https://www.unepfi.org/net-zero-banking/",
					trackingMeta: ""
				},
				{
					icon: "",
					alt: "",
					headline: "Responsibility and Impact",
					subhead: "Focused on making an impact by supporting a sustainable and inclusive future",
					link: "https://www.wellsfargo.com/about/corporate-responsibility/",
					trackingMeta: ""
				}
			]
		}
	},
	videos: {
		"LJBYYYl_yjo": {
			youtubeID: "LJBYYYl_yjo",
			transcript:
				"<p>On-screen text:<br />Wells Fargo’s Open for Business Fund is donating roughly $420 Million to help small business recovery<br /><br />Voiceover:<br />Hope.<br /><br />No matter what anyone says, it’s never really gone.<br /><br />It’s always right there.<br /><br />Just waiting for us to welcome it back.<br /><br />To hear it’s music again.<br /><br />Music<br /><br />Voiceover:<br />And maybe let it take the wheel for a while.<br /><br />It’s a feeling<br /><br />that can start with just one of us,<br /><br />and then it grows,<br /><br />through the whole community.<br /><br />That’s why Wells Fargo is lending hope a hand.<br /><br />Going to real businesses across the country,<br /><br />and working together to invest in one thing<br /><br />every person, in every town needs.<br /><br />Welcome to Hope, USA.<br /><br />On-screen text:<br />Join us by supporting local small businesses<br /><br />Wells Fargo logo<br /><br />On-screen text:<br />&copy;2021 Wells Fargo Bank, N.A. All rights reserved.</p>"
		},
		sectionMedia: [
			{
				title: "See how Wells&nbsp;Fargo Team Members came together for their communities",
				src: '/videos/video-1.mp4#t=0.001',
				poster: '/images/videos/video-poster-1.jpg',
				captions: '/videos/video-1.vtt',
				desc: "Volunteers from Wells&nbsp;Fargo worked together with local organizations to help beautify and revitalize business districts in over a dozen cities.",
				button: "Wells&nbsp;Fargo Team Members came together for their communities",
				alt: "View of the Philadelphia skyline behind low-rise row houses. Click to play video.",
				transcriptText:
					"Sound:<br />Uplifting music begins playing<br /><br />On-screen text:<br />Philadelphia, PA<br /><br />On-screen text:<br />Andre Jones Strategy & Small Business Development Wells Fargo<br /><br />Andre Jones:<br />Every day I get the chance to talk to small businesses in the community and they&rsquo;re hurting. This is why this is so special.<br /><br />On-screen text:<br />Panning shot of 52nd street sign<br /><br />On-screen text:<br />Jamie Gauthier Philadelphia City Council 3rd District<br /><br />Jamie Gauthier:<br />I spent a lot of time on 52nd Street growing up. This is a hugely important commercial corridor to the West Philadelphia region. It also is a place for black owned business and culture and art.<br /><br />On-Screen text:<br />Panning shot of ACAF African Cultural Art Forum building<br /><br />On-screen text:<br />A.J. Jordan Sr VP & Head of Community Relations, Wells Fargo<br /><br />A.J. Jordon:<br />When you look at years of disinvestment that have taken place you look at some of the racial inequality that has happened over the years, most recently COVID. The community has really taken a hit, so it&rsquo;s really efforts like this that sends a message that we all need to come together and really step up if we&rsquo;re going to turn things around.<br /><br />On-screen text:<br />Barri Rafferty Exec VP, Head of Communications and Brand Management, Wells Fargo<br /><br />Barri Rafferty:<br />Wells Fargo&rsquo;s Hope USA program is really setting out to help beautify and support local business districts this holiday season.<br /><br />On-screen text:<br />Bill Daley Vice Chairman of Public Affairs Wells Fargo<br /><br />On-screen text:<br />St. Louis, MO<br /><br />On-screen text:<br />Atlanta, GA<br /><br />Bill Daley:<br />Hope USA is an effort we&rsquo;ve put together with community groups around 16 cities to go into neighborhoods that are struggling. We have a number of team members from Wells Fargo here, working cleaning up the neighborhood, working with people from the neighborhood, contractors from the neighborhood.<br /><br />On-screen text:<br />David Miree Head of Consumer & Small Business Diverse Customer Segments, Wells Fargo<br /><br />David Miree:<br />Hope USA is an opportunity for Wells Fargo team members to come together with community leaders, local officials, community individuals and make a difference in the small business community.<br /><br />On-screen text:<br />Della Clark President & CEO The Enterprise Center<br /><br />Della Clark:<br />The important thing is this attention will help us to spring forward and that is so, so important. It&rsquo;s really something that we have hoped and prayed for, for a long time to get this kind of boost of hope.<br /><br />Sound:<br />Uplifting music<br /><br />On-screen text:<br />Panning shot of building first blank, then painted with mural that reads, &ldquo;Hope lies in dreams, in imagination, and in the courage of those who dare to make dreams into reality.&rdquo;<br /><br />On-screen text:<br />Anne Marie Ariosto Wells Fargo<br /><br />Anne Marie Ariosto:<br />It gives them the hope that, wow, like our community can look like that, like our community can feel like that.<br /><br />On-screen text:<br />Stephen Briggs Vice President, Community Relations, Pennsylvania & Delaware, Wells Fargo<br /><br />Stephen Briggs:<br />I&rsquo;m extremely proud for the company for which I work to support this effort. I think it means to the small businesses that someone cares and hopefully that will attract not only individuals from the community coming out to support their businesses, but individuals outside the community as well.<br /><br />Stephen Briggs:<br />Hope.<br /><br />Bill Daley:<br />Hope.<br /><br />A.J. Jordon:<br />Hope.<br /><br />All together:<br />Hope.<br /><br />Sound:<br />Uplifting music fades out<br /><br />On-screen text:<br />Panning shot of building with mural that reads, &ldquo;Hope lies in dreams, in imagination, and in the courage of those who dare to make dreams into reality.&rdquo;"
			},
			{
				title: "The Kelly Clarkson Show: Surprising a Philadelphia small business owner",
				src: 'https://www.facebook.com/KellyClarksonShow/posts/1317269828745628',
				poster: '/images/videos/video-poster-2.jpg',
				desc: "Ellen Bryant-Brown of Hope Rising Learning Center gives back to her community so we gave her a $10,000 grant for everything she does.",
				button: "The Kelly Clarkson Show: Surprising a Philadelphia small business owner",
				alt: "Kelly Clarkson hugs Ellen Bryant-Brown during an interview on the stage of her TV show. Click to go to video."
			},
			{
				title: "The Kelly Clarkson Show: Helping out a New York candy store",
				src: 'https://www.facebook.com/KellyClarksonShow/posts/1295929094213035',
				poster: '/images/videos/video-poster-3.jpg',
				desc: "Economy Candy owners Mitchell and Skye took were forced to take their candy store online in 2020. We gave them a $10,000 grant to help them keep up their progress over the past year.",
				button: "The Kelly Clarkson Show: Helping out a New York candy store",
				alt: "Mitchell and Skye smiling on the stage of the Kelly Clarkson TV show. Click to go to video."
			},
			{
				title: "GMA Feature: Giving back to a pharmacist that gives so much to others",
				src: 'https://www.facebook.com/GoodMorningAmerica/posts/10158853258002061',
				poster: '/images/videos/video-poster-4.jpg',
				desc: "Dr. Taquina Warren's Focus Pharmacy quickly became a key part of her local community. To say thanks, we made a $10,000 donation to the American Diabetes Association in her name.",
				button: "GMA Feature: Giving back to a pharmacist that gives so much to others",
				alt: "GMA contributor, Megan Ryte introduces a news segment on the set of the Good Morning America TV show. Click to go to video."
			}
		]
	}
};


const tileGA = [
	{
		tab: {
			cta: {
				gaTag: "isf_C10",
			},
			gaTag: "isf_C5",
		},
		panel: {
			cta: {
				gaTag: "isf_C10",
			},
		}
	},

	{
		tab: {
			cta: {
				gaTag: "isf_C11",
			},
			gaTag: "isf_C6",
		},
		panel: {
			cta: {
				gaTag: "isf_C11",
			},
		}
	},

	{
		tab: {
			cta: {
				gaTag: "isf_C14",
			},
			gaTag: "isf_C8",
		},
		panel: {
			cta: {
				gaTag: "isf_C14",
			},
		},

	},

	{
		tab: {
			cta: {
				gaTag: "isf_C13",
			},
			gaTag: "isf_C7"
		},
		panel: {
			cta: {
				gaTag: "isf_C13",
			},
		}
	},


]

